import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Order } from '../../../../models/orderModel';
import { OrderShuttleService } from '../../../../services/ordershuttle.service';
import { AdminService } from '../../../../services/admin.service';
import { ParkingService } from '../../../../services/parking.service';
import { DatePipe } from '@angular/common';
import { ConfirmDeleteComponent } from '../../users/edit-user/confirm-delete/confirm-delete.component';
import { OrderShuttleVM } from '../../../../models/orderModel';
import { MatDialog } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../services/backoffice.service';

export class TabItem {
  header: string;
  orderShuttleId: string;
  orderShuttle: OrderShuttleVM;
}

@Component({
    selector: 'app-hotel-shuttle-service-edit',
    templateUrl: './hotel-shuttle-service-edit.component.html',
    styleUrls: ['./hotel-shuttle-service-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HotelShuttleServiceEditComponent implements OnInit, OnDestroy {
  orderId: string;
  order: Order;
  tabList: TabItem[] = [];
  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public params: any,
    public snackBar: MatSnackBar,
    public orderShuttleService: OrderShuttleService,
    public adminService: AdminService,
    public parkingService: ParkingService,
    public datepipe: DatePipe,
    public dialog: MatDialog,
    public backofficeService: BackOfficeService
  ) {}

  ngOnInit(): void {
    this.orderId = this.params.orderId;
    this.getOrder(this.orderId);
    this.getOrderShuttles(this.orderId);
  }

  getOrderShuttles(orderId: string) {
    this.orderShuttleService
    .getOrderShuttleOrderId(orderId)
    .pipe(takeUntil(this.componentDestroyed$))
    .subscribe(orderShuttles => {
      orderShuttles.forEach(orderShuttle => {
        this.addOrderShuttleTab(orderShuttle);
      });
    });
  }

  getOrder(orderId: string) {
    this.backofficeService
      .getOrder(orderId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(order => {
        this.order = order;
      });
  }

  addOrderShuttleTab(orderShuttle: OrderShuttleVM): void {
    this.tabList.push(<TabItem>{header: orderShuttle.shuttleTypeName, orderShuttleId: orderShuttle.orderShuttleId, orderShuttle: orderShuttle });
  }

  setOrderstatusCancel(orderId: string) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      data: {
        message: `Är du säker på att du vill cancellera bokningen?`,
        buttonText: {
          ok: 'Ja',
          cancel: 'Avbryt'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if(confirmed) {
        this.backofficeService
        .setOrderstatusCancel(orderId)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(status => {
          this.snackBar.open('Bokningen är cancellerad!', 'OK', {
            duration: 5000,
            verticalPosition: 'top'
          });
        });
      }
    });
  }

  sendOrderConfirmation(orderId: string) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      data: {
        message: `Är du säker på att du vill skicka orderbekräftelse?`,
        buttonText: {
          ok: 'Ja',
          cancel: 'Avbryt'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if(confirmed) {
        this.backofficeService
        .sendOrderConfirmation(orderId)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(status => {
          this.snackBar.open('Orderbekräftelse skickad!', 'OK', {
            duration: 5000,
            verticalPosition: 'top'
          });
        });
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
